// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2VmxF","info":"Note_info__1ZzNw","note":"Note_note__30a2w","actions":"Note_actions__qYq-D"};